import React from 'react';
import { useNavigate } from 'react-router-dom';

const ActionCard = ({ icon, title, desc, note, onClick, color = 'var(--primary)' }) => (
  <div style={{
    backgroundColor: 'var(--card-bg)', padding: '0.75rem', borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: `3px solid ${color}`,
    display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer'
  }} onClick={onClick}>
    <div style={{ fontSize: '1.5rem' }}>{icon}</div>
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: '600', fontSize: '12px' }}>{title}</div>
      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{desc}</div>
      {note && (
        <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{note}</div>
      )}
    </div>
    <span style={{ color: 'var(--text-muted)', fontSize: '14px' }}>→</span>
  </div>
);

// pokazZaawansowane: przyjmowane dla zgodnosci sygnatury ze strona faktur.
// DZIS nie ukrywa niczego — 'Nowa faktura reczna' zostaje dla wszystkich,
// bo nie importuje pliku XML i nie tworzy produktow z pliku.
const QuickActions = ({ pokazZaawansowane = false }) => { // eslint-disable-line no-unused-vars
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '4px', boxShadow: '0 1px 2px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
      <div style={{ padding: '0.5rem 0.75rem', borderBottom: '1px solid var(--border)', fontWeight: '600', fontSize: '12px', backgroundColor: 'var(--bg)' }}>
        ⚡ Szybkie akcje
      </div>
      <div style={{ padding: '0.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <ActionCard icon="➕" title="Nowa faktura ręczna" desc="Dodaj fakturę ręcznie" note="Bez importu pliku — pozycje wpisujesz ręcznie" onClick={() => navigate('/purchase-invoices/new')} color="var(--success)" />
        <ActionCard icon="📋" title="Lista wszystkich faktur" desc="Przeglądaj i zarządzaj" onClick={() => navigate('/purchase-invoices/list')} />
        <ActionCard icon="📊" title="Raporty zakupów" desc="Statystyki i analizy" onClick={() => navigate('/purchase-invoices/reports')} color="var(--info)" />
      </div>
    </div>
  );
};

export default QuickActions;
